import { Button as IOButton } from '@descomplica/foundation-ui-components';
import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.div<{
  fullWidth?: boolean;
}>`
  & > button {
    width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
  }
`;

type Props = {
  fullWidth?: boolean;
  className?: string;
  style?: React.CSSProperties;
  variant?: 'primary' | 'secondary';
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  loading?: boolean;
  icon?: any;
  size?: 'small' | 'medium' | 'large';
};

export const Button: React.FC<Props> = (props) => (
  <StyledButton fullWidth={props.fullWidth} className={props.className} style={props.style}>
    <IOButton size="medium" {...props} />
  </StyledButton>
);
